import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/services/common/common.service';
import { SideBarService } from 'src/app/services/common/side-bar.service';
import { MessageService } from 'src/app/services/message.service';
declare const bootstrap: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements AfterViewInit {
  @ViewChild('myCanvas') myCanvas: any;

  loginForm: FormGroup;
  changePasswordForm!: FormGroup;
  showPassword!: boolean;
  newPassword!: boolean;
  confirmPassword!: boolean;
  isResetPasswordEnable: boolean = false;
  loginResponse: any;
  userName: any;
  StrongPasswordRegx: RegExp =
    /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
  validRoute: any[] = [];
  siteKey: string = `6LcUmtcpAAAAAK19t_v-CJaRVrtTZ6slKlsB3Akr`;
  captcha: string = '';
  isFieldTouched!: boolean;

  myInterval = 13000;
  activeSlideIndex = 0;
  slides: { image: string; text?: string }[] = [
    { image: 'assets/images/image1.png' },
    { image: 'assets/images/image2.png' },
    { image: 'assets/images/image3.png' },
  ];

  passwordRules: any = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  };

  urlFromWhichCaptchaToRemove: string = 'https://dev-ui3.zoeiesg.com/login'; // for testing purpose
  captchaCurrentUrl: string = window.location.href;
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private _sidebarService: SideBarService
  ) {
    this.loginForm = this._fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      //captcha: ['', Validators.required],
    });

    // add the captcha form control only when the current url is not the one from which we have to remove captcha, this is for testing purpose
    if (this.captchaCurrentUrl !== this.urlFromWhichCaptchaToRemove) {
      this.loginForm.addControl(
        'captcha',
        this._fb.control('', Validators.required)
      );
    }

    var con = document
      .getElementById('pwd')
      ?.addEventListener('keydown', function (event) {
        if (event.key === 'F4' || (event.ctrlKey && event.key === 'v')) {
          event.preventDefault();
        }
      });
  }

  ngAfterViewInit(): void {
    this.startCarouselManual();
    // generate captcha only when the current url is not the one from which we have to remove captcha, this is for testing purpose
    if (this.captchaCurrentUrl !== this.urlFromWhichCaptchaToRemove) {
      this.generateCaptcha();
    }
  }

  ngOnInit(): void {
    // this.removeLocalStorageData();
    this.changeFormInitialize();
    // setTimeout(() => {}, 4000);
  }

  startCarouselManual() {
    setTimeout(() => {
      var myCarousel = document.querySelector('#carouselExampleControls');
      var carousel = new bootstrap.Carousel(myCarousel, {
        interval: 4000,
        wrap: true,
        touch: false,
        keyboard: false,
      });
    }, 0);
  }

  generateCaptcha() {
    const viewportWidth = window.innerWidth;
    const canvasHeightVW = '2.5vw'; // Replace with your desired height in vw
    const canvasHeight =
      (parseFloat(canvasHeightVW.slice(0, -2)) * viewportWidth) / 100;
    this.captcha = '';
    this.loginForm.controls['captcha'].reset();
    var chars: any =
      '0123456789ABCDEFGHJKLMNOPQRSTUVWXTZabcdefghikmnopqrstuvwxyz'.split('');
    var length: any = 6;

    if (!length) {
      length = Math.floor(Math.random() * chars.length);
    }

    for (var i = 0; i < length; i++) {
      this.captcha += chars[Math.floor(Math.random() * chars.length)];
    }
    var c: any = document?.getElementById('myCanvas');
    var ctx = c.getContext('2d');
    ctx.canvas.height = canvasHeight - 2;

    ctx.clearRect(0, 0, 200, 200);
    ctx.moveTo(0, 17);
    ctx.fillStyle = '#FFFFFF';
    ctx.lineTo(200, 17);
    ctx.strokeStyle = '#FFFFFF';
    ctx.stroke();
    ctx.font = '23px Arial';

    ctx.fillText(this.captcha, 10, 24);
  }

  changeFormInitialize() {
    this.changePasswordForm = this._fb.group({
      currentPassword: ['', Validators.required],
      newPassword: [
        '',
        [Validators.required, Validators.pattern(this.StrongPasswordRegx)],
      ],
      confirmPassword: [
        '',
        [Validators.required, Validators.pattern(this.StrongPasswordRegx)],
      ],
    });
  }

  removeLocalStorageData() {
    localStorage.removeItem('userData');
    localStorage.removeItem('authToken');
    localStorage.removeItem('imageUrl');
    localStorage.removeItem('validRoutes');
    localStorage.removeItem('userAccessModule');
  }

  login() {
    if (!this.loginForm?.valid) {
      this.loginForm.markAllAsTouched();

      return this.messageService.errorToast('Please fill required details.');
    } else {
      if (
        this.loginForm.value.captcha === this.captcha ||
        this.captchaCurrentUrl == this.urlFromWhichCaptchaToRemove
      ) {
        this.commonService.userLogin(this.loginForm.value).subscribe(
          (response: any) => {
            this.userName = response.data.username;
            this.isFieldTouched = false;
            this.loginResponse = response.data;
            if (response.data.isPasswordChanged) {
              localStorage.setItem('logoImg', response.data?.logo);
              this.commonService._logoImgPath.next(response.data?.logo);
              localStorage.setItem('userData', JSON.stringify(response.data));
              localStorage.setItem('authToken', response.data.accessToken);
              localStorage.setItem(
                'appVersion',
                response.data?.angularAppVersion[0]?.version
              );
              this.commonService.userLoggedIn.next(true); // to tell the app component that user logged in so that we can start the count()
            }

            this.validRoute = response.data.userAccessModule;

            localStorage.setItem(
              'userAccessModule',
              JSON.stringify(this.validRoute)
            );

            const sidebarMenu = this._sidebarService.generateSidebar(
              this.validRoute
            );

            this.commonService.userMenu = sidebarMenu;

            localStorage.setItem('validRoutes', JSON.stringify(sidebarMenu));

            if (!response.data.isPasswordChanged) {
              this.isResetPasswordEnable = true;
              this.captcha = '';
              this.loginForm.reset();
              this.spinner.hide();
              this.generateCaptcha();
            } else {
              this.isResetPasswordEnable = false;
              this.commonService.userLoggedIn.next(true);
              this.router.navigate(['dashboard']);
              this.commonService.isStandardScreenModelOpen = true;
              this.loginForm.reset();
            }
          },
          (err: any) => {
            this.loginForm.reset();
            this.spinner.hide();
          }
        );
      } else {
        this.messageService.errorToast('Please Enter Valid Captcha');
      }
    }
  }

  passwordChange() {
    if (!this.isPasswordValid()) return;

    if (this.changePasswordForm.invalid) {
      if (
        this.changePasswordForm.controls['currentPassword'].hasError(
          'required'
        ) ||
        this.changePasswordForm.controls['newPassword'].hasError('required') ||
        this.changePasswordForm.controls['confirmPassword'].hasError('required')
      ) {
        this.messageService.errorToast('Please Fill all the fields');
        return;
      } else if (
        this.changePasswordForm.controls['newPassword'].hasError('pattern') ||
        this.changePasswordForm.controls['confirmPassword'].hasError('pattern')
      ) {
        this.messageService.errorToast(
          'Password should be of min 8 digits contains Alphanumeric, Special Character and Uppercase and Lowercase characters'
        );
        return;
      }
    } else {
      if (
        this.changePasswordForm.value.newPassword !=
        this.changePasswordForm.value.confirmPassword
      ) {
        this.messageService.errorToast(
          "New Password and confirm Password don't match"
        );
      } else {
        this.spinner.show();
        let requestBody = {
          userNameOrEmail: this.userName,
          oldPassword: this.commonService.encryptData(
            this.changePasswordForm.value.currentPassword
          ),
          newPassword: this.commonService.encryptData(
            this.changePasswordForm.value.newPassword.trim()
          ),
        };
        this.commonService.changePassword(requestBody).subscribe((res: any) => {
          if (res.isSuccess) {
            this.isFieldTouched = false;
            this.isResetPasswordEnable = false;
            this.removeLocalStorageData();
            setTimeout(() => {
              this.generateCaptcha();
            }, 0);
            this.changePasswordForm.reset();
            this.messageService.successToast('Password changed successfully');
            this.commonService.userLoggedIn.next(false); // not to tell the app component that user logged in so that we can start the count()
          } else {
            this.messageService.errorToast(res.errorMessage);
          }
          this.spinner.hide();
        });
      }
    }
  }

  get passwordTouched() {
    return this.changePasswordForm.get('newPassword')?.touched;
  }

  checkPasswordStrength() {
    const password = this.changePasswordForm.get('newPassword')?.value || '';

    this.passwordRules = {
      minLength: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[@$!%*?&*!~><?|\\[\]{}\-\+_=()]/.test(password),
    };
  }

  isPasswordValid(): boolean {
    return Object.values(this.passwordRules).every(rule => rule);
  }

  isFormReadyToSubmit(): boolean {
    const current = this.changePasswordForm
      .get('currentPassword')
      ?.value?.trim();
    const newPass = this.changePasswordForm.get('newPassword')?.value?.trim();
    const confirm = this.changePasswordForm
      .get('confirmPassword')
      ?.value?.trim();

    return (
      current &&
      newPass &&
      confirm &&
      newPass === confirm &&
      this.isPasswordValid()
    );
  }
}
